// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* XmotLogicSetting Component Styles */

/* Main container */
.xmot-logic-container {
  margin-top: 1rem;
}

/* Settings button */
.logic-settings-button {
  float: left;
}

/* Overlay panel */
.xmot-overlay-panel {
  padding: 0;
}

/* Overlay content wrapper */
.xmot-overlay-content {
  width: 500px;
}

/* Header section */
.xmot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #dee2e6;
}

.xmot-header-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
}

.xmot-close-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 30px;
  color: #6c757d;
  padding: 0;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Content section */
.xmot-content {
  padding: 20px;
}

/* Field sections */
.xmot-field-section {
  margin-bottom: 20px;
}

.xmot-field-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}

.xmot-field-input-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

/* Input fields */
.xmot-duration-input {
  width: 70px;
  text-align: center;
  padding: 6px;
}

.xmot-duration-input.p-invalid {
  border-color: #e24c4c;
}

.xmot-magnitude-input {
  width: 70px;
  text-align: center;
  padding: 6px;
  font-size: 14px;
}

.xmot-magnitude-input.p-invalid {
  border-color: #e24c4c;
}

/* Error messages */
.xmot-error-message {
  color: #e24c4c;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.xmot-duration-error {
  margin-left: 140px;
}

.xmot-magnitude-error {
  margin-left: 155px;
}

/* Radio buttons section */
.xmot-radio-section {
  margin-bottom: 15px;
}

.xmot-radio-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.xmot-radio-item {
  display: flex;
  align-items: center;
}

.xmot-radio-label {
  margin-left: 8px;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
}

/* Send after section (conditional) */
.xmot-send-after-wrapper {
  margin-left: 5px;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.xmot-dropdown-value {
  width: 85px;
}

.xmot-dropdown-unit {
  width: 130px;
}

/* Action buttons */
.xmot-actions {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  padding-top: 16px;
}

.xmot-cancel-button {
  background: #f5f5f5;
  color: #212529;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  font-size: 14px;
}

.xmot-apply-button {
  background: #212529;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 20px;
  font-size: 14px;
}

/* Utility class for font size */
.fs-14 {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/logicsettings.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,eAAe;AACjB","sourcesContent":["/* XmotLogicSetting Component Styles */\n\n/* Main container */\n.xmot-logic-container {\n  margin-top: 1rem;\n}\n\n/* Settings button */\n.logic-settings-button {\n  float: left;\n}\n\n/* Overlay panel */\n.xmot-overlay-panel {\n  padding: 0;\n}\n\n/* Overlay content wrapper */\n.xmot-overlay-content {\n  width: 500px;\n}\n\n/* Header section */\n.xmot-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.xmot-header-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.xmot-close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 30px;\n  color: #6c757d;\n  padding: 0;\n  line-height: 1;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Content section */\n.xmot-content {\n  padding: 20px;\n}\n\n/* Field sections */\n.xmot-field-section {\n  margin-bottom: 20px;\n}\n\n.xmot-field-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.xmot-field-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #666;\n}\n\n/* Input fields */\n.xmot-duration-input {\n  width: 70px;\n  text-align: center;\n  padding: 6px;\n}\n\n.xmot-duration-input.p-invalid {\n  border-color: #e24c4c;\n}\n\n.xmot-magnitude-input {\n  width: 70px;\n  text-align: center;\n  padding: 6px;\n  font-size: 14px;\n}\n\n.xmot-magnitude-input.p-invalid {\n  border-color: #e24c4c;\n}\n\n/* Error messages */\n.xmot-error-message {\n  color: #e24c4c;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n.xmot-duration-error {\n  margin-left: 140px;\n}\n\n.xmot-magnitude-error {\n  margin-left: 155px;\n}\n\n/* Radio buttons section */\n.xmot-radio-section {\n  margin-bottom: 15px;\n}\n\n.xmot-radio-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.xmot-radio-item {\n  display: flex;\n  align-items: center;\n}\n\n.xmot-radio-label {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #212529;\n  cursor: pointer;\n}\n\n/* Send after section (conditional) */\n.xmot-send-after-wrapper {\n  margin-left: 5px;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #666;\n}\n\n.xmot-dropdown-value {\n  width: 85px;\n}\n\n.xmot-dropdown-unit {\n  width: 130px;\n}\n\n/* Action buttons */\n.xmot-actions {\n  display: flex;\n  justify-content: flex-start;\n  gap: 12px;\n  padding-top: 16px;\n}\n\n.xmot-cancel-button {\n  background: #f5f5f5;\n  color: #212529;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-size: 14px;\n}\n\n.xmot-apply-button {\n  background: #212529;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 20px;\n  font-size: 14px;\n}\n\n/* Utility class for font size */\n.fs-14 {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
